import { AddressModel } from '@fi-app/utilities/address/address.model';
import { BillingContactModel } from '../billing-contact.model';
import { Injector } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';

export class BusinessUnitCompanyInformationModel {
    Id: number;
    Name: string;
    BusinessUnitId: number;
    BusinessUnitName: string;
    Description: string;
    AllowChangeHeadQuarter: boolean;
    VATNumber: { CountryCode: string; Number: string };
    ChargeVAT: boolean;
    IsHeadQuarter: boolean;
    Address: AddressModel;
    UnitStatusName: string;
    Contacts: BillingContactModel[];

    constructor(data, injector: Injector) {
        this.Id = 0;
        this.BusinessUnitId = 0;
        this.Name = '';
        this.BusinessUnitName = '';
        this.Description = '';
        this.IsHeadQuarter = true;
        this.AllowChangeHeadQuarter = true;
        this.ChargeVAT = true;
        this.VATNumber = { CountryCode: '', Number: '' };

        this.intPropertiesWithObjects(this);

        if (data) this.Initialize(data);

        this.initNames(injector.get(AppTextService));
    }

    private Initialize(data) {
        Object.assign(this, data);
        this.intPropertiesWithObjects(this);

        if (data.Address && data.Address.Id > 0) this.Address.Initialize(data.Address);

        if (data.Contacts && data.Contacts.length > 0) {
            this.Contacts = [];
            data.Contacts.forEach((contact, index) => {
                const contactModel = new BillingContactModel();
                contactModel.Initialize(contact);
                this.Contacts.push(contactModel);
            });
        }
    }

    private intPropertiesWithObjects(data: BusinessUnitCompanyInformationModel) {
        data.Address = new AddressModel();
        data.Contacts = [new BillingContactModel()];
        data.Contacts[0].IsDefault = true;
    }

    initNames(appTextService: AppTextService) {
        this.UnitStatusName = appTextService.get(this.IsHeadQuarter ? 'head_quarter' : 'regular_unit');
    }
}
